import React, { useState } from "react";
import PublicIcon from "@mui/icons-material/Public";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import styles from "./LanguageSwitcher.module.css";
import { saveLanguagePreference } from "../utils/userPreferences";

const LANGUAGE_OPTIONS: Array<{ code: string; label: string }> = [
  { code: "en", label: "English" },
  { code: "ko", label: "한국어" },
  { code: "ja", label: "日本語" },
  { code: "ar", label: "العربية" },
  { code: "da", label: "Dansk" },
  { code: "de", label: "Deutsch" },
  { code: "el", label: "Ελληνικά" },
  { code: "es-ES", label: "Español (España)" },
  { code: "es-MX", label: "Español (México)" },
  { code: "fa", label: "فارسی" },
  { code: "fi", label: "Suomi" },
  { code: "fr", label: "Français" },
  { code: "he", label: "עברית" },
  { code: "hi", label: "हिन्दी" },
  { code: "id", label: "Bahasa Indonesia" },
  { code: "it", label: "Italiano" },
  { code: "ms", label: "Bahasa Melayu" },
  { code: "nb", label: "Norsk Bokmål" },
  { code: "nl", label: "Nederlands" },
  { code: "pl", label: "Polski" },
  { code: "pt-BR", label: "Português (Brasil)" },
  { code: "pt-PT", label: "Português (Portugal)" },
  { code: "ru", label: "Русский" },
  { code: "sv", label: "Svenska" },
  { code: "th", label: "ไทย" },
  { code: "tr", label: "Türkçe" },
  { code: "uk", label: "Українська" },
  { code: "vi", label: "Tiếng Việt" },
  { code: "zh-CN", label: "简体中文（中国）" },
  { code: "zh-TW", label: "繁體中文（台灣）" },
];

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const getLanguagePath = (language: string) => {
    const currentPath = location.pathname.split("/").slice(2).join("/");
    return currentPath ? `/${language}/${currentPath}` : `/${language}`;
  };

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    saveLanguagePreference(language);
    setIsOpen(false);
  };

  return (
    <div className={styles.languageSwitcherContainer}>
      <button onClick={toggleMenu} className={styles.languageButton}>
        <PublicIcon className={styles.languageIcon} aria-hidden="true" />
        {t("language_switcher.languages")}
      </button>
      <div className={styles.languageMenu} hidden={!isOpen}>
        {LANGUAGE_OPTIONS.map((option) => (
          <Link
            key={option.code}
            to={getLanguagePath(option.code)}
            onClick={() => changeLanguage(option.code)}
            className={styles.languageMenuItem}
            hrefLang={option.code}
          >
            {option.label}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
